import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Calendar } from "lucide-react";

const Events = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow py-16 md:py-24">
        <div className="container px-4 md:px-6">
          <div className="mb-12 text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">Upcoming Events</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Join our live workshops, group sessions, and Q&As with top coaches and therapists focused on BIPOC mental health.
            </p>
          </div>
          
          <div className="flex flex-col items-center justify-center py-12 px-4 bg-background/40 rounded-xl">
            <Calendar className="h-16 w-16 text-primary mb-4" />
            <h2 className="text-xl font-medium text-gray-900 mb-2">No events scheduled at the moment</h2>
            <p className="text-gray-600 text-center max-w-md">
              We're currently planning our next series of events. Please check back soon or subscribe to our newsletter to be notified.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Events;
